import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogActions from '@mui/material/DialogActions'
import { Button } from '../../../components/buttons'
import { intl } from '../../../../i18n'

type Props = {
  open: boolean
  tokenName: string
  onConfirm: () => void
  onCancel: () => void
  loading: boolean
}

const RevokeConfirmDialog = ({
  open,
  tokenName,
  onConfirm,
  onCancel,
  loading,
}: Props) => {
  return (
    <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth={true}>
      <DialogTitle>
        {intl.formatMessage({
          id: 'userApiToken.revokeDialog.title',
        })}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {intl.formatMessage(
            { id: 'userApiToken.revokeDialog.message' },
            { tokenName }
          )}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ padding: 2 }}>
        <Button
          colorPattern="monotone"
          variant="outlined"
          onClick={onCancel}
          disabled={loading}
        >
          {intl.formatMessage({ id: 'dialog.cancel' })}
        </Button>
        <Button
          variant="filled"
          colorPattern="pink"
          onClick={onConfirm}
          disabled={loading}
        >
          {intl.formatMessage({
            id: 'userApiToken.revokeDialog.confirm',
          })}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default RevokeConfirmDialog
